<template>
    <app-layout>
        <template #header>
            <AppHead title="Account Finance" />
            <div class="row py-2">
                <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
                    <h2 class="title">Account Finance</h2>
                </div>
            </div>
            <flash-messages />
        </template>

        <div class="py-2">
            <div class="bg-white p-3">
                <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                        <inertia-link :class="tab == 'history' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'history')">History</inertia-link>
                    </li>
                    <li class="nav-item" v-if="!is_linked">
                        <inertia-link :class="tab == 'payouts' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'payouts')">Payout History</inertia-link>
                    </li>
                    <li class="nav-item">
                        <inertia-link :class="tab == 'cash' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'cash')">Cash/Checks</inertia-link>
                    </li>
                    <li class="nav-item">
                        <inertia-link :class="tab == 'salestax' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'salestax')">Tax Collected</inertia-link>
                    </li>
                </ul>
                <card class="border-top-0">
                    <div class="tab-content" id="transactions_content">

                        <div class="tab-pane fade show active pt-3" v-if="tab == 'payouts'">
                            <PayoutHistory :payouts="payouts" :noPayoutItems="noPayoutItems" />
                        </div>

                        <div class="tab-pane fade show active pt-3" v-if="tab == 'cash'">
                            <div v-for="session in cash_sessions" :key="session.id" class="mb-3">
                                <CashTable :session="session" :has_linked="has_linked" />
                            </div>

                            <CashDrawer :drawer="drawer" :has_linked="has_linked" />
                        </div>


                        <div class="tab-pane fade show active pt-3" v-if="tab == 'salestax'">

                            <div class="clearfix">
                                <h3>Orders with Tax</h3>
                                <div class="row mb-3">
                                    <div class="col-12 text-right my-2" v-if="orders.length">
                                        <jet-button class="px-2 btn-sm" btnStyle="success" @click="exportHistory()"
                                            icon="fa fa-download">Export</jet-button>
                                    </div>
                                    <div class="col-6">
                                        <select class="form-control" @change="selectMonth($event)">
                                            <option v-for="(item, index) in months" :key="item.id" :value="index"
                                                :selected="item.monthNum == month && item.year == year">{{ item.month }} {{
                                                    item.year }}</option>
                                        </select>
                                    </div>
                                    <div class="col-6">

                                        <select class="form-control" @change="selectCounty()" v-model="this.filter_county">
                                            <option :value="null">Select County</option>
                                            <option v-for="(county, index) in counties" :key="index"
                                                :value="county && county.length > 0 ? county : -1">{{ county &&
                                                    county.length > 0 ? county : "Unknown" }}</option>
                                        </select>
                                    </div>
                                </div>
                                <span v-if="orders.length === 0"></span>
                                <DataTable :value="orders" v-else class="p-datatable-sm" responsiveLayout="stack"
                                    stripedRows dataKey="id">
                                    <Column field="created_at" header="Date">
                                        <template #body="slotProps">
                                            {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
                                        </template>
                                    </Column>
                                    <Column field="id" header="Order #">
                                        <template #body="slotProps">
                                            <inertia-link class="text-right"
                                                :href="route('mtd.order.view', slotProps.data.id)">
                                                {{ slotProps.data.id }}
                                            </inertia-link>
                                        </template>
                                    </Column>
                                    <Column field="customer" header="Customer">
                                        <template #body="slotProps">
                                            {{ slotProps.data.user.first_name }} {{ slotProps.data.user.last_name }}
                                        </template>
                                    </Column>
                                    <Column field="total" header="Total" headerClass="header-right" class="table-right">
                                        <template #body="slotProps">
                                            {{ formatDollars(slotProps.data.total) }}
                                        </template>
                                    </Column>
                                    <Column field="sales_tax_amount" header="Tax" headerClass="header-right"
                                        class="table-right">
                                        <template #body="slotProps">
                                            {{ formatDollars(slotProps.data.sales_tax_amount) }}
                                        </template>
                                    </Column>

                                    <Column field="sales_tax_amount" header="County" headerClass="header-right"
                                        class="table-right">
                                        <template #body="slotProps">
                                            {{ slotProps.data.tax_address?.area_county }}
                                        </template>
                                    </Column>

                                </DataTable>
                                <div class="float-right">
                                    <div v-if="tax_total > 0">
                                        <strong>Total Tax:</strong> {{ formatDollars(this.tax_total) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </card>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import Icon from '@/Shared/Icon'
import moment from 'moment'
import Calendar from 'primevue/calendar';
import CashTable from '@/Components/Transaction/CashTable'
import CreditsTable from '@/Components/Transaction/CreditsTable'
import PayoutHistory from '@/Components/Transaction/PayoutHistory'
import CashDrawer from '@/Components/Transaction/CashDrawer'

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetInput,
        JetCheckbox,
        JetInputError,
        JetLabel,
        Icon,
        Calendar,
        CreditsTable,
        CashTable,
        CashDrawer,
        PayoutHistory,
    },
    props: {
        tab: String,
        has_linked: Boolean,
        is_linked: Boolean,
        current: Boolean,
        monthText: String,
        month: Number,
        year: Number,
        months: Array,
        summary: Object,
        history: Array,
        totals: Object,
        start_date: String,
        end_date: String,
        trucks: Array,
        types: Array,
        payment_types: Array,
        drawer: Object,
        payouts: Array,
        noPayoutItems: Array,
        cash_sessions: Array,
        payment: Object,
        invoices: Array,
        payout_id: Number,

        orders: Array,
        tax_total: Number,
        counties: Array,
        county: String
    },
    data() {
        return {
            selected_start_date: this.start_date ? new Date(this.start_date) : null,
            selected_end_date: this.end_date ? new Date(this.end_date) : null,
            selected_types: this.types,
            selected_payment_type: this.payment_types,
            selected_trucks: this.trucks,
            selected_payout_id: this.payout_id,
            filter_county: this.county
        }
    },
    created: function () {
        this.moment = moment;
    },
    methods: {
        filterSet(period, type, truck) {
            let now = null;
            switch (period) {
                case 'today':
                    now = moment().startOf('day');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = null;
                    break;
                case 'yesterday':
                    now = moment().subtract(1, 'days').startOf('day');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(1, 'days').toDate();
                    break;
                case 'week':
                    now = moment.utc().startOf('day').startOf('isoWeek');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(7, 'days').toDate();
                    break;
                case 'lastweek':
                    now = moment.utc().startOf('day').startOf('isoWeek').subtract(7, 'days');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(7, 'days').toDate();
                    break;
            }

            if (!truck) {
                this.selected_trucks = [];
            } else {
                this.selected_trucks = [truck];
            }

            this.filterType(type);
        },
        filterType(type, payment_type) {
            this.selected_payout_id = null;

            switch (type) {
                case 'orders':
                    this.selected_types = ['order'];
                    this.selected_payment_type = ['cc', 'ach', 'cash', 'check', 'balance'];
                    break;

                case 'order_paid':
                    this.selected_types = ['order'];
                    this.selected_payment_type = ['cc', 'ach', 'cash', 'check'];
                    break;

                case 'payments':
                    this.selected_types = ['order', 'payment'];
                    this.selected_payment_type = ['cc', 'ach', 'cash', 'check'];
                    break;

                case 'payments_balance':
                    this.selected_types = ['payment'];
                    this.selected_payment_type = ['cc', 'ach', 'cash', 'check'];
                    break;
            }

            if (payment_type) {
                this.filterPaymentType(payment_type);
            } else {
                this.filter();
            }
        },
        filterPaymentType(type) {
            this.selected_payout_id = null;

            switch (type) {
                case 'ccach':
                    this.selected_payment_type = ['cc', 'ach'];
                    break;

                default:
                    this.selected_payment_type = [type];
                    break;
            }

            this.filter();
        },
        filter() {
            if (this.selected_payout_id) {
                this.selected_types = ['order', 'payment'];
                this.selected_payment_type = ['cc', 'ach'];
            }
            this.$inertia.visit(route('mtd.history', {
                start_date: this.selected_start_date ? moment(this.selected_start_date).format('YYYY-MM-DD') : null,
                end_date: this.selected_end_date ? moment(this.selected_end_date).format('YYYY-MM-DD') : null,
                trucks: this.selected_trucks,
                type: this.selected_types,
                payment_type: this.selected_payment_type,
                payout_id: this.selected_payout_id,
            }), {
                preserveScroll: true
            })
        },
        selectMonth: function (e) {
            let month = this.months[e.target.value];

            this.$inertia.visit(route('mtd.history', { tab: 'salestax', year: month.year, month: month.monthNum }));
        },
        selectCounty: function () {
            this.$inertia.visit(route('mtd.history', { tab: 'salestax', year: this.year, month: this.month, county: this.filter_county }));
        },
        exportHistory() {
            axios.post(route('mtd.history.export', { tab: 'salestax', year: this.year, month: this.month, county: this.filter_county }), {}, {
                responseType: 'blob'
            })
                .then(response => {
                    this.downloadResponse(response, 'salestax_export.xlsx')
                })
        }
    }
}
</script>

<style>
.header-right .p-column-header-content {
    justify-content: end;
}

.p-datatable .p-datatable-tbody>tr>td.table-right {
    text-align: right;
}

.amount-detail {
    cursor: pointer;
    color: blue;
}

.amount-detail i {
    font-size: 9px;
}</style>